import { useState, type FormEvent } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { Button, Input } from '@/components'
import { useAuth } from '@/lib/auth'
import { pesanKesalahan } from '@/lib/api'

export default function Login() {
  const { masuk, pengguna, siap, memuat } = useAuth()
  const navigate = useNavigate()
  const lokasi = useLocation()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [galat, setGalat] = useState<string | null>(null)

  if (siap && pengguna) {
    return <Navigate to={pengguna.mustChangePassword ? '/ganti-kata-sandi' : '/'} replace />
  }

  const kirim = async (e: FormEvent) => {
    e.preventDefault()
    setGalat(null)
    if (!username.trim() || !password) {
      setGalat('Nama pengguna dan kata sandi wajib diisi.')
      return
    }
    try {
      const profil = await masuk(username.trim(), password)
      if (profil.mustChangePassword) {
        navigate('/ganti-kata-sandi', { replace: true })
        return
      }
      const dari = (lokasi.state as { dari?: string } | null)?.dari
      navigate(dari && dari !== '/login' ? dari : '/', { replace: true })
    } catch (err) {
      setGalat(pesanKesalahan(err))
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-yayasan-900 via-yayasan-800 to-yayasan-950 p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center text-yayasan-50">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-yayasan-50 text-lg font-bold text-yayasan-900">
            YYS
          </div>
          <h1 className="text-xl font-semibold">Sistem Informasi Keuangan Terpadu</h1>
          <p className="mt-1 text-sm text-yayasan-200">Yayasan, Pondok Pesantren, dan Sekolah</p>
        </div>

        <form
          onSubmit={kirim}
          className="space-y-4 rounded-2xl border border-white/10 bg-white p-6 shadow-xl"
          noValidate
        >
          <h2 className="text-base font-semibold text-netral-900">Masuk ke akun Anda</h2>

          {galat ? (
            <div role="alert" className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
              {galat}
            </div>
          ) : null}

          <Input
            label="Nama pengguna"
            autoComplete="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="mis. bendahara.pondok"
            required
          />

          <Input
            label="Kata sandi"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <Button type="submit" lebarPenuh ukuran="besar" memuat={memuat}>
            Masuk
          </Button>

          <p className="text-center text-xs text-netral-500">
            Zona waktu Asia/Jakarta · Mata uang Rupiah (IDR)
          </p>
        </form>

        <p className="mt-4 text-center text-xs text-yayasan-200">
          Hubungi administrator yayasan bila Anda tidak dapat mengakses akun.
        </p>
      </div>
    </div>
  )
}
